const parseGatheringIdentifier = (
	identifier: string,
):
	| {
			gatheringId: string;
	  }
	| {
			refCode: string;
	  } => {
	if (identifier.length === 36) {
		return { gatheringId: identifier };
	}
	return { refCode: identifier };
};
export default parseGatheringIdentifier;
